import styles from './InquiryChips.module.scss';

interface LabelChipProps {
  name: string;
  color: string;
  onDelete?: () => void;
  size?: 'small' | 'medium';
}

export default function LabelChip({ name, color, onDelete }: LabelChipProps) {
  return (
    <span
      className={styles.labelChip}
      style={{ backgroundColor: `${color}20`, color }}
    >
      {name}
      {onDelete && (
        <button
          className={styles.labelDeleteBtn}
          onClick={(e) => { e.stopPropagation(); onDelete(); }}
          style={{ color }}
        >
          ✕
        </button>
      )}
    </span>
  );
}
